import { GetAccountGroupsShareApi } from "@/features/accounts/account-group/services/get-account-groups-share-api";
import { GetAccountGroupsShareRequestModel } from "@/features/accounts/account-group/services/get-account-groups-share-model";

/// 口座グループ共有メンバー取得
export class GetAccountGroupsShareService {
  private getAccountGroupsShareApi = new GetAccountGroupsShareApi();

  /**
   * 口座グループ共有メンバー取得
   */
  public async getAccountGroupsShare(param: GetAccountGroupsShareRequestModel) {
    return await this.getAccountGroupsShareApi.getAccountGroupsShare(param);
  }
}

